var rich_content_viewer_default = {
  "fontElementMap": "QYSbm",
  "wrapper": "l0umV",
  "pluginContainerMobile": "_92BYn",
  "viewer": "o3Rjw",
  "android": "dPSJl",
  "rootedTraversedContent": "_5gFbG",
  "atomic": "V3LV8",
  "toolbar": "A-BQR",
  "block": "oWjeN"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
